import { render, staticRenderFns } from "./user-permissions-card.vue?vue&type=template&id=03926b77&scoped=true&"
import script from "./user-permissions-card.vue?vue&type=script&lang=ts&"
export * from "./user-permissions-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03926b77",
  null
  
)

export default component.exports